import { KeyValueType } from "../../../Types/keyValueType"
import { Form, Formik } from "formik"
import { TextInputField } from "../../FormFields/TextInput/TextInputField"
import { DateInputField } from "../../FormFields/DateInput/DateInputField"
import { Button } from "react-bootstrap"


const generateBlankKeyValue = () => ({
    namespace: '',
    key: '',
    value: '',
    expiresAt: undefined,
    createdAt: new Date(),
    updatedAt: new Date()
})

export default function KeyValueForm(props: {
    disabled: boolean,
    onSubmit: (v: any) => Promise<any>,
    initialValues?: Partial<KeyValueType>,
}) {
    const {
        disabled,
        onSubmit,
        initialValues,
    } = props

    let convertedValueText = ''
    
    if (initialValues) {
        try {
            convertedValueText = initialValues?.value ? (typeof initialValues.value === 'string' ? initialValues.value : JSON.stringify(initialValues.value, null, 2)) : ''
        } catch (e) {
            convertedValueText = ''
        }
    }
    
    

    return (
        <div className="key-value-form">
            <Formik
                initialValues={{
                    ...generateBlankKeyValue(),
                    ...(initialValues ? initialValues : {}),
                    value: convertedValueText
                }}
                validate={values => {
                    const errors: any = {};

                    if (!values.namespace) {
                        errors.namespace = 'Namespace is required';
                    }

                    if (!values.key) {
                        errors.key = 'Key is required';
                    }

                    if (!values.value.trim()) {
                        errors.value = 'Value is required';
                    }

                    // Validate values.value is valid JSON if it looks like JSON
                    if (values.value.trim().startsWith('{') || values.value.trim().startsWith('[')) {
                        try {
                            JSON.parse(values.value)
                        } catch (e) {
                            errors.value = 'Value must be valid JSON if it starts with { or ['
                        }
                    }

                    return errors;
                }}
                onSubmit={async (values, { setSubmitting }) => {
                    if (onSubmit) {
                        try {
                            // Convert value text to appropriate type
                            let valueObject: any = ''
                            
                            // Try to parse as JSON if it looks like JSON
                            if (values.value.trim().startsWith('{') || values.value.trim().startsWith('[')) {
                                try {
                                    valueObject = JSON.parse(values.value)
                                } catch (e) {
                                    // Keep as string if JSON parsing fails
                                    valueObject = values.value
                                }
                            } else if (values.value.trim() === 'true' || values.value.trim() === 'false') {
                                valueObject = values.value.trim() === 'true'
                            } else if (!isNaN(Number(values.value.trim())) && values.value.trim() !== '') {
                                valueObject = Number(values.value.trim())
                            }

                            onSubmit({
                                ...values,
                                value: valueObject
                            })
                        } catch (err) {
                            // custom error handler
                        }
                    }
                    setSubmitting(false)
                }}
            >
                {({ values, isSubmitting, errors, touched, setFieldValue, handleChange, setValues }) => {
                    return (
                        <>
                            <Form>
                                <h3>🔑 Key-Value Information</h3>
                                <TextInputField
                                    fieldType="text"
                                    fieldLabel="Namespace"
                                    placeholder="e.g., app-config, user-settings, cache"
                                    fieldName="namespace"
                                />

                                <TextInputField
                                    fieldType="text"
                                    fieldLabel="Key"
                                    placeholder="e.g., api-endpoint, theme-preference, session-data"
                                    fieldName="key"
                                />

                                <h3>💾 Value</h3>
                                <TextInputField
                                    fieldType="textarea"
                                    fieldLabel="Value"
                                    placeholder="Enter the value (string, number, boolean, or JSON object/array)"
                                    fieldName="value"
                                />

                                <h3>⏰ Expiration (Optional)</h3>
                                <DateInputField
                                    fieldLabel="Expires At"
                                    placeholder="Leave empty for no expiration"
                                    fieldName="expiresAt"
                                />

                                <hr />
                                <div className="mb-3">
                                    Errors: {JSON.stringify(errors)}
                                </div>

                                <Button
                                    className="mb-3"
                                    type="submit"
                                    disabled={Object.keys(errors).length > 0 || isSubmitting || disabled}
                                >
                                    Submit
                                </Button>

                            </Form>
                        </>
                    )
                }}
            </Formik>
        </div>
    )
}